<template>
  <div
    id="sellers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >

              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.name"
                  :rules="[rules.required]"
                  :maxlength="100"
                  label="Nombre"
                  placeholder="Nombre del Plan"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.description"
                  :rules="[rules.required]"
                  :maxlength="100"
                  label="Descripción"
                  placeholder="Descripción del plan"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.quantity"
                  :rules="[rules.required, rules.numeric]"
                  :maxlength="20"
                  label="Cantidad"
                  placeholder="Cantidad"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.coin"
                  :rules="[rules.required, rules.numeric]"
                  :maxlength="20"
                  label="NIKKON"
                  placeholder="NIKKON"
                  required
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    metaInfo() {
      return { title: this.$t('plans') };
    },
    components: {
      FormToolbar,
    },
    props: {
      id: { default: null },
    },
    data: () => ({
      form: new Form({
        data: {},
        name: '',
        description: '',
        quantity: '',
        coin: '',
        active: '1',
      }),
      errores: null,
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        numeric: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Plan',
      apiURL: '/api/catalogs/plans',
      method: 'POST',
      disabledOnEdit: false,
      dialogAyuda: false,

    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      const URL = `${this.apiURL}/store`;
      this.URL = URL;
      if (this.id) {
        this.URL = `${this.apiURL}/${this.id}/update`;
        window.axios.get(`${this.apiURL}/${this.id}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.disabledOnEdit = true;
          this.method = 'PUT';
          this.title = 'Editar Plan';
          this.message = `Se ha editado el Plan ${result.data.name} exitosamente.`;
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then(() => {
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
